<script>
import router from "../../router";
import { send } from "q";
export default {
  name: "ViewPurchaseOrder",
  components: {},
  data() {
    return {
      order: {
        purchase_order: {
          supplier: {}
        },
        additional_fees: [],
        items: []
      },
      to_email: "",
      from_email: "",
      subject: "",
      currency: "",
      decimal_separator: ".",
precision: 0,
      cc_email: ""
    };
  },
  methods: {
    details(id) {
      this.$api
        .getAPI({
          _action: "/order/detail/" + id
        })
        .then(res => {
          this.order = res;

          this.subject =
            "Purchase order from " +
            this.order.purchase_order.store_name +
            " (" +
            this.order.purchase_order.po_number +
            ")";

          this.from_email = this.order.purchase_order.email;
        });
    },
    edit() {
      if (this.order.purchase_order.id) {
        router.push("/edit-purchase-order/" + this.order.purchase_order.id);
      }
    },
    receive() {
      if (this.order.purchase_order.id) {
        router.push("/receive-purchase-order/" + this.order.purchase_order.id);
      }
    },
    approve() {
      if (this.order.purchase_order.id) {
        this.$api
          .getAPI({
            _action: "/order/approve/" + this.order.purchase_order.id
          })
          .then(res => {
            this.details(this.order.purchase_order.id);
          });
      }
    },
    gettoback() {
      router.push("/purchase-order");
    },
    checkSend() {
      this.$validator.validateAll("modifier-form").then(result => {
        if (result) {
          this.sendMail1();
          return;
        }
      });
    },
    sendMail1() {
      var abc = {
        from_email: this.from_email,
        to_email: this.to_email,
        cc_email: this.cc_email,
        subject: this.subject,
        id: this.order.purchase_order.id
      };
      this.$api
        .postAPI({
          _action: "/order/send_mail",
          _body: abc,
          _buttonId: "save-btn"
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });
          document.getElementById("cancel-btn").click();
        })
        .catch(e => {
          console.log(e.message);
        });
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.details(this.$route.params.id);
    }
    this.decimal_separator = localStorage.getItem("decimal_separator") || ".";
this.precision = (localStorage.getItem("decimal_separator") || "") == "" ? 0 : 2;
  }
};
</script>
<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-9">
            <div class="card rounded-5 border">
              <div class="card-header bg-white border-bottom px-lg-5 px-4 py-4">
                <div class="row">
                  <div class="col-lg-4 col-md-5 align-self-center mb-md-0 mb-3">
                    <a href="javascript:void(0)" @click="gettoback()" class="text-primary">
                      <i class="mdi mdi-chevron-left"></i>
                      {{$lang.messages.purchase_order}}
                    </a>
                  </div>
                  <div class="col-lg-8 col-md-7 text-right">
                    <a
                      v-if="order.purchase_order.order_status == 'DRAFT'"
                      href="javascript:void(0)"
                      class="btn btn-outline-primary mr-2 mb-lg-0 mb-2"
                      style="min-width: auto"
                      @click="edit()"
                    >
                      <i class="mdi mdi-pencil"></i>
                    </a>
                    <button
                      v-if="order.purchase_order.order_status == 'DRAFT'"
                      @click="approve()"
                      type="button"
                      class="btn btn-primary mr-lg-2 mb-md-0 mb-3 w-xs-100"
                    >{{$lang.messages.approve}}</button>
                    <button
                      v-else-if="order.purchase_order.order_status != 'CLOSED'"
                      @click="receive()"
                      type="button"
                      class="btn btn-primary mr-lg-2 mb-md-0 mb-3 w-xs-100"
                    >{{$lang.messages.receive}}</button>
                    <button
                      v-if="order.purchase_order.order_status !== 'DRAFT' && order.purchase_order.order_status !== 'CLOSED'"
                      type="button"
                      class="btn btn-primary mr-lg-2 mb-md-0 mb-3 w-xs-100"
                      data-toggle="modal"
                      data-target="#SendPurchaseOrder"
                    >{{$lang.messages.send}}</button>
                  </div>
                </div>
              </div>
              <div class="card-body form-style px-lg-5 px-4 py-4">
                <div class="row mb-4">
                  <div class="col-lg-9">
                    <h1 class="mb-0">{{order.purchase_order.po_number}}</h1>
                    <p class="text-danger font-14">{{$lang.messages[order.purchase_order.order_status.toLowerCase()]}}</p>
                  </div>
                  <div class="col-lg-3 mb-lg-5">
                    <div class="progress m-t-15 mb-2" style="height: 10px;">
                      <div
                        class="progress-bar bg-success"
                        role="progressbar"
                        :style="{ width: order.progress+ '%' }"
                        aria-valuenow="75"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <p
                      class="font-14 text-grey"
                    >{{$lang.messages.received}} {{order.total_quantity_received ? order.total_quantity_received : '0'}} {{$lang.messages.of}} {{order.total_quantity}}</p>
                  </div>
                </div>
                <div class="row mb-5">
                  <div class="col-lg-12">
                    <table>
                      <tr>
                        <td class="pr-3 f-semi-bold">{{$lang.messages.date}}:</td>
                        <td>{{order.purchase_order.purchase_date | moment("MMM DD, YYYY") }}</td>
                      </tr>
                      <tr v-if="order.purchase_order.expected_on">
                        <td class="f-semi-bold pr-3">{{$lang.messages.expected_on}}:</td>
                        <td>{{order.purchase_order.expected_on | moment("MMM DD, YYYY") }}</td>
                      </tr>
                      <tr>
                        <td class="f-semi-bold pr-3">{{$lang.messages.ordered_by}}:</td>
                        <td>{{order.purchase_order.orderedBy}}</td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-lg-6" v-if="!!order.purchase_order.supplier">
                    <h4 class="mb-3 f-semi-bold">{{$lang.messages.supplier}}</h4>
                    <p>{{order.purchase_order.supplier.name}}</p>
                  </div>
                  <div class="col-lg-6" v-else-if="!!order.purchase_order.source_b2b_store">
                    <h4 class="mb-3 f-semi-bold">{{$lang.messages.store}}</h4>
                    <p>{{order.purchase_order.source_b2b_store.name}}</p>
                  </div>
                  <div class="col-lg-6">
                    <h4 class="mb-3 f-semi-bold">{{$lang.messages.destination_store}}</h4>
                    <p>
                      {{order.purchase_order.store_name}}
                      <br />
                    </p>
                  </div>
                  <div class="col-12 mt-4" v-if="order.purchase_order.note">
                    <p class="f-semi-bold mb-0">{{$lang.messages.notes}}:</p>
                    <p>{{order.purchase_order.note}}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <h3>{{$lang.messages.items}}</h3>
                    <div class="table-responsive">
                      <table class="table table-striped table-style-1">
                        <thead>
                          <tr>
                            <th scope="col">{{$lang.messages.item}}</th>
                            <th scope="col">{{$lang.messages.quantity}}</th>
                            <th scope="col" v-if="!!order.purchase_order.source_b2b_store">{{$lang.messages.b2b_price}}</th>
                            <th scope="col" v-else>{{$lang.messages.purchase_cost}}</th>
                            <th scope="col" class="text-right">{{$lang.messages.amount}}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="obj in order.items" :key="obj.id">
                            <td>
                              {{obj.item.name}}
                              <br />
                              <span
                                class="font-14 text-grey"
                                v-if="obj.item.sku"
                              >{{$lang.messages.sku}} {{obj.item.sku}}</span>
                            </td>
                            <td>{{obj.quantity}}</td>
                            <td>
                              <vue-numeric
                                v-bind:precision="precision"
                                :separator="decimal_separator"
                                :value="obj.cost"
                                :read-only="true"
                              />
                            </td>
                            <td class="text-right">
                              <vue-numeric
                                v-bind:precision="precision"
                                :separator="decimal_separator"
                                :value="obj.item.amount"
                                :read-only="true"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="row" v-if="order.additional_fees.length > 0">
                  <div class="col-lg-12">
                    <h3>{{$lang.messages.additional_cost}}</h3>
                    <div class="table-responsive">
                      <table class="table table-striped table-style-1">
                        <thead>
                          <tr>
                            <th scope="col">{{$lang.messages.title}}</th>
                            <th scope="col">{{$lang.messages.cost}}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="obj in order.additional_fees" :key="obj.id">
                            <td v-if="!!$lang.messages[obj.title]">{{$lang.messages[obj.title]}}</td>
                            <td v-else>{{obj.title}}</td>
                            <td>
                              <vue-numeric
                                v-bind:precision="precision"
                                :separator="decimal_separator"
                                :value="obj.cost"
                                :read-only="true"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <div class="table-responsive">
                      <table class="table table-striped table-style-1">
                        <tbody>
                          <tr style="text-align: right;">
                            <td>
                              <span class="mr-3">{{$lang.messages.total}}</span>
                              <vue-numeric
                                v-bind:precision="precision"
                                :separator="decimal_separator"
                                :value="order.purchase_order.total_amount"
                                :read-only="true"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Box send -->
    <div
      class="modal fade"
      id="SendPurchaseOrder"
      tabindex="-1"
      role="dialog"
      aria-labelledby="SendPurchaseOrder"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content px-lg-4 py-lg-4">
          <div class="modal-header border-0">
            <h5 class="modal-title font-22">{{$lang.messages.send_purchase_order_by_email}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form data-vv-scope="modifier-form">
            <div class="modal-body form-style">
              <div class="row mb-4">
                <div class="col-lg-12 mb-3">
                  <label for>{{$lang.messages.from}}</label>
                  <span style="color:#ff0000">*</span>
                  <input
                    name="from_email"
                    v-model="from_email"
                    v-validate="'required|email'"
                    :class="{ 'form-control' : true, 'input': true, 'is-danger': errors.has('modifier-form.from_email') }"
                    type="text"
                    v-bind:placeholder="$lang.messages.email"
                  />
                  <i v-show="errors.has('modifier-form.from_email')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('modifier-form.from_email')"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_email}}</span>
                </div>

                <div class="col-lg-12 mb-3">
                  <label for>{{$lang.messages.to}}</label>
                  <span style="color:#ff0000">*</span>
                  <input
                    name="to_email"
                    v-model="to_email"
                    v-validate="'required|email'"
                    :class="{ 'form-control' : true, 'input': true, 'is-danger': errors.has('modifier-form.to_email') }"
                    type="text"
                    v-bind:placeholder="$lang.messages.email"
                  />
                  <i v-show="errors.has('modifier-form.to_email')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('modifier-form.to_email')"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_email}}</span>
                </div>
                <div class="col-lg-12 mb-3">
                  <label for>{{$lang.messages.cc}}</label>
                  <input
                    name="cc_email"
                    v-model="cc_email"
                    v-validate="'email'"
                    :class="{ 'form-control' : true, 'input': true, 'is-danger': errors.has('modifier-form.cc_email') }"
                    type="text"
                    v-bind:placeholder="$lang.messages.email"
                  />
                  <i v-show="errors.has('modifier-form.cc_email')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('modifier-form.cc_email')"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_email}}</span>
                </div>
                <div class="col-lg-12 mb-4">
                  <label for>{{$lang.messages.subject}}</label>
                  <input type="text" name="subject" v-model="subject" class="form-control" id />
                </div>
                <div class="col-lg-12">
                  <label class="mb-0">{{$lang.messages.message}}</label>
                  <p class="font-14 text-grey">{{$lang.messages.attachment}}</p>
                  <p class>
                    <i class="mdi mdi-file-pdf mr-2"></i>
                    {{order.purchase_order.po_number}}
                  </p>
                </div>
              </div>
            </div>
            <div class="modal-footer border-0 justify-content-center">
              <button
                type="button"
                class="btn btn-primary mr-3"
                id="save-btn"
                @click="checkSend()"
              >{{$lang.messages.send}}</button>
              <button
                type="button"
                data-dismiss="modal"
                id="cancel-btn"
                class="btn btn-outline-primary"
              >{{$lang.messages.cancel_btn_text}}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
